export const EMEARegion = 'EU';
export const NARegion = 'NA';
export const LARegion = 'LA';
export const EMEARegionSalesOrg='3601';
export const UserTypeInternal='Internal';
export const UserTypeCustomer='Customer';

